import React from "react"
import TimelineGroupItem from "./timeline-group-item"
import { sampleItem } from "@/routes/(app)/_layout/inventory/$itemId/-data/fixtures"

export default function Timeline() {
  const item = sampleItem
  return (
    <div className="space-y-6">
      <div className="text-xs text-muted-foreground">2025</div>
      {item.timeline.map((group, gi) => (
        <TimelineGroupItem
          key={group.id}
          group={group}
          last={gi === item.timeline.length - 1}
          isRecent={gi === 0}
        />
      ))}
    </div>
  )
}

